<mat-sidenav-container class="mainWrapper blue_theme  light-theme" autosize autoFocus dir="ltr">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->

    <mat-sidenav #leftsidenav id="mobile-navigation" [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
                 [autoFocus]="isOver"
                 (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
        <div class="flex-layout">
            <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>

            <div class="sidebar-scroll">
                <mat-accordion [multi]="false" class="product-accordion">
                    @if (navSections.length === 0) {
                        <div class="empty-nav-state">
                            <p>No products are currently enabled for this client.</p>
                        </div>
                    } @else {
                        @for (section of navSections; track section.product) {
                            <mat-expansion-panel
                                    (closed)="onSectionClosed(section.product)"
                                    (opened)="onSectionOpened(section.product)"
                                    [expanded]="isSectionExpanded(section.product)"
                                    [ngClass]="{'active-product-section': section.product === activeProduct}"
                                    class="product-section"
                                    hideToggle="true">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="product-section-header">
                                            <i-tabler [name]="getProductIcon(section.product)"
                                                      class="product-icon"></i-tabler>
                                            <span class="product-title">{{ section.product }}</span>
                                        </div>
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <i-tabler
                                                class="chevron-icon"
                                                [name]="isSectionExpanded(section.product) ? 'chevron-up' : 'chevron-down'">
                                        </i-tabler>
                                    </mat-panel-description>
                                </mat-expansion-panel-header>

                                <mat-nav-list class="sidebar-list">
                                    @for (group of section.groups; track group?.title ?? $index; let groupIndex = $index) {
                                        @if (group.title) {
                                            <button
                                                    type="button"
                                                    class="nav-caption-toggle"
                                                    (click)="toggleGroup(section.product, group.title, groupIndex)">
                                                <span>{{ group.title }}</span>
                                                <i-tabler
                                                        class="chevron-icon"
                                                        [name]="isGroupExpanded(section.product, group.title, groupIndex) ? 'chevron-up' : 'chevron-down'">
                                                </i-tabler>
                                            </button>
                                        }

                                        @if (!group.title || isGroupExpanded(section.product, group.title, groupIndex)) {
                                            <div class="nav-group-items expanded">
                                                @for (item of group.items; track item) {
                                                    <app-nav-item (notify)="sidenav.toggle()" [item]="item">
                                                    </app-nav-item>
                                                }
                                            </div>
                                        }
                                    }
                                </mat-nav-list>
                            </mat-expansion-panel>
                        }
                    }
                </mat-accordion>
            </div>
        </div>
    </mat-sidenav>

    <mat-sidenav #rightsidenav mode="over" position="end">
        <ng-template #content></ng-template>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper" #content>
        <!-- ============================================================== -->
        <!-- VerticalHeader -->
        <!-- ============================================================== -->

        <app-header [showToggle]="!isOver" [toggleChecked]="leftsidenav.opened" (toggleCollapsed)="toggleCollapsed()"
                    (toggleMobileNav)="sidenav.toggle()"></app-header>
        <main [ngClass]="{'maxWidth': !fullWidthContent, 'fullWidth': fullWidthContent}" class="pageWrapper">
            <!-- ============================================================== -->
            <!-- Outlet -->
            <!-- ============================================================== -->
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>

</mat-sidenav-container>
